import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';

export type ButtonVariant = 'basic' | 'flat' | 'stroked' | 'raised';
@Component({
  selector: 'app-action-btn',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule
  ],
  host: {
    'class': 'tw-inline-block',
    '[class.tw-cursor-pointer]': '!disabled',
    '[class.tw-cursor-not-allowed]': 'disabled',
    '[style.pointer-events]': 'disabled ? "none" : "auto"'
  },
  templateUrl: './action-btn.component.html',
  styleUrl: './action-btn.component.scss'
})
export class ActionBtnComponent {
  // @Input() type: 'primary' | 'secondary' = 'primary';
  @Input() color: ThemePalette = 'primary';
  @Input() variant: ButtonVariant = 'flat';
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  
  get customClasses(): string {
    const base = 'tw-h-11 tw-px-4 tw-rounded-xl tw-text-base tw-font-medium tw-transition-all tw-duration-200 tw-cursor-pointer ';

    if(this.fullWidth) return base + "tw-w-full";

    // if (this.type === 'primary') {
    //   return base + 'tw-bg-[var(--sys-primary)] tw-text-white hover:tw-brightness-110';
    // } else {
    //   return base + 'tw-text-[var(--sys-text)] tw-bg-transparent hover:tw-bg-[var(--sys-hover)]';
    // }
    return base
  }
}